<div class="header-parent-title">
  <div class="header-child-title">Locations</div>
  <div class="header-child-title">.</div>
</div>
<div class="gbp-post-locations-table">
  <app-locations-list [tableData]="tableData" [addLocation]="addLocation" (searchKeyword)="updateTableData($event)"></app-locations-list>
  <p-paginator
    styleClass="multiselect-paginator"
    [rows]="paginatorRows"
    [totalRecords]="paginatorLength"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} locations.'"
    (onPageChange)="onPageChange($event)"
  >
  </p-paginator>
</div>
